import * as THREE from 'three';
import { useContext, useEffect, useState } from 'react';
import { FileLoaderOptionsContext } from '../FileLoaderOptionsContext';
import { useLoader } from '@react-three/fiber';
import { TextureLoader } from './TextureLoader';

type Props = {
  url: string;
  requestHeader?: { [header: string]: string };
  withCredentials?: boolean;
};

export const useTextureLoader = ({ url, requestHeader, withCredentials }: Props) => {
  const fileLoaderOptions = useContext(FileLoaderOptionsContext);
  const [loader, setLoader] = useState<TextureLoader>();
  const texture: THREE.Texture = useLoader(TextureLoader, url, (loader) => {
    setLoader(loader);
    loader.setWithCredentials(withCredentials ?? fileLoaderOptions.withCredentials);
    if (requestHeader) {
      loader.setRequestHeader(requestHeader);
    }
  });

  useEffect(() => {
    return () => {
      useLoader.clear(TextureLoader, url);
    };
  }, [url]);

  useEffect(() => {
    return () => {
      loader?.dispose();
    };
  }, [loader]);

  return { texture };
};
